import React from "react";
import {
    Divider,
    Drawer,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import { useLocation } from "react-router-dom";
import TextTransform from "../TextTransform";
import styles from "./styles";

type Props = {
    disabled: boolean,
    items: Array<any>,
    onClose: Function,
    open: boolean
};

/**
 * App Drawer Component
 * @param {Props} props
 */

export default ({ disabled = false, items, onOpen, onClose, open = false }) => {
    const classes = makeStyles(styles)();
    const location = useLocation();

    return (
        <Drawer anchor="left" onClose={onClose} open={open}>
            <div className={classes.appBarToolbarSpacer} />
            <Divider />
            {items.map((item) => {
                const color = location.pathname.startsWith(item.path)
                    ? "primary"
                    : "inherit";

                return !item.disabled ? (
                    <React.Fragment key={item.key}>
                        <ListItemButton
                            className={classes.listItem}
                            disabled={disabled || item.disabled}
                            onClick={() => {
                                onClose();
                                item.onClick();
                            }}
                        >
                            <Tooltip
                                disableFocusListener={open}
                                disableHoverListener={open}
                                disableTouchListener={open}
                                title={item.primary.toUpperCase()}
                            >
                                <ListItemIcon>
                                    <item.Icon color={color} />
                                </ListItemIcon>
                            </Tooltip>
                            <ListItemText
                                primary={
                                    <TextTransform upperCase>
                                        {item.primary}
                                    </TextTransform>
                                }
                                primaryTypographyProps={{ color }}
                            />
                        </ListItemButton>
                        <Divider />
                    </React.Fragment>
                ) : null;
            })}
        </Drawer>
    );
};
